import { render, staticRenderFns } from "./mixForm.vue?vue&type=template&id=476677ac&scoped=true"
import script from "./mixForm.vue?vue&type=script&lang=js"
export * from "./mixForm.vue?vue&type=script&lang=js"
import style0 from "./mixForm.vue?vue&type=style&index=0&id=476677ac&prod&lang=scss&scoped=true"
import style1 from "./mixForm.vue?vue&type=style&index=1&id=476677ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476677ac",
  null
  
)

export default component.exports